"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PayStubsCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const PayStubs_1 = __importDefault(require("../api/PayStubs"));
const UserContext_1 = require("../contexts/UserContext");
const Card_1 = __importDefault(require("../components/Card"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const Loading_1 = __importDefault(require("../components/Loading"));
const Button_1 = __importDefault(require("../components/Button"));
const TableHeader_1 = __importDefault(require("../components/TableHeader"));
const PayStub_1 = __importDefault(require("../partials/PayStub"));
const react_i18next_1 = require("react-i18next");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
function PayStubsCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size, columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState(null);
    const [payStubs, setPayStubs] = react_1.default.useState(null);
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => {
            PayStubs_1.default.getLatest(token, 2).then(data => {
                setPayStubs(data?.paystubs);
                setStatus('done');
            });
        }).catch(e => {
            setPayStubs(null);
            setStatus((e == 404) ? 'done' : 'error');
        }));
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, []);
    const payStubClick = (id, date) => {
        props.navigation.navigate('PayStubDetail', { voucherId: id, date });
    };
    return ((0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: t('common:screenTitles.stubs'), style: { marginBottom: 8 }, children: (0, jsx_runtime_1.jsxs)(Button_1.default, { type: "outline", accessibilityHint: t('myPay:hints.payCard'), onPress: () => props.navigation.navigate('PayStubs', { year: (new Date()).getFullYear() }), children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Primary, fontSize: 14, fontWeight: '500', marginHorizontal: 6 }, children: t('myPay:buttons.viewAll') }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Regular.ChevronRight, size: 14, style: { marginRight: 6 } })] }) }), status == 'done'
                &&
                    (0, jsx_runtime_1.jsxs)(FadeInView_1.default, { children: [(0, jsx_runtime_1.jsx)(TableHeader_1.default, { columns: [
                                    { flex: 2, label: '' },
                                    { flex: 4, label: t('myPay:text.date') },
                                    { flex: 4, label: t('myPay:text.net') },
                                    { flex: 1, label: '' },
                                ] }), (payStubs != null && payStubs.length > 0)
                                &&
                                    (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginHorizontal: 0, marginBottom: -4 }, children: payStubs?.slice(0, 2).map((item, index, array) => (0, jsx_runtime_1.jsxs)(react_native_1.View, { children: [(0, jsx_runtime_1.jsx)(PayStub_1.default, { item: item, label: (index == 0) ? t('myPay:text.latest') : null, onPress: () => payStubClick(item.voucherId, item.payDate) }), (index < array.length - 1) &&
                                                    (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [STYLES.separator] })] }, item.voucherId)) })
                                ||
                                    (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { alignItems: "center", justifyContent: "center", marginVertical: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.MoneyCheckDollar, size: 48, color: THEME.ImageNull, style: { marginBottom: 6 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: (size != 'sm' ? 16 : 14), color: THEME.TextNull, textAlign: 'center' }, children: t('myPay:text.noStubs') })] })] })
                ||
                    (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() })] }));
}
;
